var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        persistent: "",
        "max-width": "1000px",
        "content-class": "report-error-dialog",
        fullscreen: _vm.$vuetify.breakpoint.smAndDown,
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _vm.dialog
        ? [
            _c(
              "v-flex",
              [
                _c(
                  "v-card",
                  { attrs: { flat: "", dark: "" } },
                  [
                    _c(
                      "v-toolbar",
                      { attrs: { dark: "", color: "primary" } },
                      [
                        _c("v-toolbar-title", [_vm._v("Missing Parameters")]),
                        _vm._v(" "),
                        _c("v-spacer"),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: { icon: "", dark: "" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.close()
                              },
                            },
                          },
                          [_c("v-icon", [_vm._v("close")])],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-flex",
              { staticStyle: { overflow: "auto" } },
              [
                _c(
                  "v-card",
                  { attrs: { flat: "" } },
                  [
                    _c("v-card-text", [
                      _c("div", { staticClass: "mb-4 mt-2" }, [
                        _vm._v(
                          "\n            The following missing parameters could not be matched to existing data. "
                        ),
                        _c("br"),
                        _vm._v(
                          "\n            This can happen if data is modified. One common example is if the analyte is updated or merged.\n            Please let us know so we can fix this for you.\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "subheading font-weight-medium mb-2" },
                        [_vm._v("Missing Parameters")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c("TreeView", {
                            attrs: { data: { value: _vm.missingParams } },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-flex",
              [
                _c(
                  "v-card",
                  { staticStyle: { "border-top": "1px solid #dddddd" } },
                  [
                    _c(
                      "v-card-actions",
                      [
                        _c("v-spacer"),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: { color: "warning" },
                            on: {
                              click: function ($event) {
                                return _vm.clearMissingParams()
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t("Button.RemoveMissingParameters")
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: { color: "secondary", outline: "" },
                            on: {
                              click: function ($event) {
                                return _vm.close()
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("Button.Close")))]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }